import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { SideMenuContainer } from "./styled/common";
import {
  IoChevronDown,
  IoChevronUp,
  IoNotificationsOutline,
  IoSearchOutline,
} from "react-icons/io5";
import { GrClose } from "react-icons/gr";

import AuthButtons from "./header/authButtons";

export default function SideMenu({
  clickSideMenu,
  setClickSideMenu,
  menuItems,
  handleLogout,
  extracted,
  type,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });
  const user = useSelector((state) => state?.user?.data[0]);

  const [notify, setNotify] = useState([]);

  useEffect(() => {
    if (user && isTablet) {
      getNotification();
    }
  }, [user]);

  const getNotification = async () => {
    try {
      const res = await axios.post("/api/notificationHistory", { mberNo: user.mberNo });
      setNotify((res?.data || []).filter((not) => not.readYn === "N"));
    } catch (error) {
      console.error(error);
    }
  };

  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const openWindow = () => {
    window.open(`https://1472.ai/mypage/notify`);
  };

  return (
    <SideMenuContainer
      className={extracted()}
      style={{
        transform: clickSideMenu ? "translateX(0)" : "translateX(200%)",
        opacity: clickSideMenu ? 1 : 0,
      }}>
      <div className="wrapper">
        <div className="sideMenuInfo">
          <div className="logo">
            <span>MONOTI</span>
          </div>
          <div className="buttons">
            <button onClick={() => navigate("/mypage/search")}>
              <IoSearchOutline />
            </button>
            <button onClick={() => openWindow()}>
              <IoNotificationsOutline />
            </button>
            <button onClick={() => setClickSideMenu(false)}>
              <GrClose />
            </button>
          </div>
        </div>
        <div className="gbn">
          <ul>
            {menuItems.map((menu, index) => (
              <li key={index}>
                <button className="toggle" onClick={() => toggleMenu(index)}>
                  <span>{menu.title}</span>
                  {menu.items && (
                    <span className="icon">
                      {openMenuIndex === index ? <IoChevronUp /> : <IoChevronDown />}
                    </span>
                  )}
                </button>
                {menu.items && (
                  <ul
                    style={{
                      height: openMenuIndex === index ? `${menu.items.length * 35}px` : "0",
                      overflow: "hidden",
                      transition: "height 0.3s ease",
                    }}
                    className="menuItem">
                    {menu.items.map((item, i) => (
                      <li key={i}>
                        <Link
                          to={item.link}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (menu.action && typeof menu.action === "function") {
                              dispatch(menu.action(i));
                            }
                            setClickSideMenu(false);
                          }}>
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className="authButtons">
          <AuthButtons
            setClickSideMenu={setClickSideMenu}
            handleLogout={handleLogout}
            type={type}
          />
        </div>
      </div>
    </SideMenuContainer>
  );
}
